/* eslint-disable no-param-reassign */
import { Reducer } from 'redux';
import produce from 'immer';
import { IVacationState, VacationTypes } from './types';

const INITIAL_STATE: IVacationState = {
  data: [],
  disabled: false,
  printing: false,
  loading: false,
  error: false,
};

const vacation: Reducer<IVacationState> = (state = INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case VacationTypes.LOAD_VACATION_REQUEST: {
        draft.loading = true;
        break;
      }
      case VacationTypes.LOAD_VACATION_SUCCESS: {
        draft.data = action.payload.data;
        draft.disabled = action.payload.data.length === 0;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case VacationTypes.LOAD_VACATION_FAILURE: {
        draft.data = [];
        draft.disabled = false;
        draft.loading = false;
        draft.error = true;
        break;
      }
      case VacationTypes.PRINT_VACATION_REQUEST: {
        draft.printing = true;
        break;
      }
      case VacationTypes.PRINT_VACATION_SUCCESS: {
        draft.printing = false;
        draft.error = false;
        break;
      }
      case VacationTypes.PRINT_VACATION_FAILURE: {
        draft.printing = false;
        break;
      }
      default:
        break;
    }
  });
};

export default vacation;
